'use client';

import { useCallback } from 'react';

import { useAtom, useSetAtom } from 'jotai';

import { Button } from '@gds/Button/Button';
import Grid from '@gds/Grid/Grid';
import { Search } from '@gds/Icons/Paths/Search';
import { useModal } from '@modal/Hooks/UseModal';
import { nlsToggleAtom } from '@natural-language-search/Atoms/NaturalLanguageSearchToggle.atom';
import { NaturalLanguageSearch } from '@natural-language-search/NaturalLanguageSearch';
import { validateUrl } from '@search/Utils/ValidateUrl';

import { navTrayOpenAtom } from '../../../Atoms/NavTrayOpenAtom';
import { itemOnClick, trackingFunction } from '../../TrackedLink/TrackedLink';

import styles from '../NavButtons.module.css';

type Props = {
  strings: Record<string, string>;
  isDesktopEnabled?: boolean;
};

export const SearchButton = ({ strings, isDesktopEnabled }: Props) => {
  const SearchBar = useCallback(
    () => <NaturalLanguageSearch validateUrl={validateUrl} strings={strings} isPrimaryHeader />,
    [],
  );

  const [isToggleSearchBtnOn, setToogleSearchBtnOn] = useAtom(nlsToggleAtom);
  const setIsNavTrayOpen = useSetAtom(navTrayOpenAtom);
  const { closeModal } = useModal();

  const toggleSearchBar = () => {
    setToogleSearchBtnOn?.(!isToggleSearchBtnOn);
    setIsNavTrayOpen(false);
    closeModal();
  };

  return (
    <>
      <Button
        className={styles.item}
        aria-label="Search"
        data-is-desktop-enabled={String(!!isDesktopEnabled)}
        onClick={() =>
          itemOnClick(
            {
              fn: trackingFunction,
              obj: { label: 'Mobile Search Toggle' },
            },
            () => toggleSearchBar(),
          )
        }
      >
        <Search />
      </Button>
      <Grid.Container className={styles.searchBarWrapper}>
        <SearchBar />
      </Grid.Container>
    </>
  );
};
